import { Styles } from "@chakra-ui/theme-tools";
import { ThemeColor } from "./palette";

const APP_BACKGROUND = "#0c1117";

export const styles: Styles = {
    global: {
        // Base colour lives on <html> only. Keeping body/#root transparent lets a
        // page render a fixed, full-bleed background layer at z-index -1 (it paints
        // above <html>'s background but below content) — used by the /ansem partner
        // backdrop. Other pages are unchanged: <html> still fills the viewport.
        html: {
            fontSize: "62.5%",
            bg: APP_BACKGROUND,
        },
        // Explicitly transparent (overrides Chakra's CSS reset, which otherwise
        // paints body with chakra-body-bg) so the /ansem fixed backdrop at
        // z-index -1 shows through. <html> supplies the base colour everywhere.
        body: {
            bg: "transparent",
            color: ThemeColor.CONTENT,
            fontSize: "md",
        },
        "#root": {
            minHeight: "100vh",
            bg: "transparent",
        },
    },
};
